import { gql } from '@apollo/client';

export const GQL_GET_MATERIAL_REPORT = gql`
  query GetMaterialReport($where: String!) {
    getMaterialStats(where: $where) {
      materialId
      materialName
      collectionsCount
      firstCollection
      firstCollectionCode
      lastCollection
      lastCollectionCode
      totalQty
      totalWeight
      avgWeightPerCollection
      collectorBreakdown {
        collectorId
        collectorName
        collectionsCount
        firstCollection
        lastCollection
        totalQty
        totalWeight
        avgWeightPerCollection
      }
    }
  }
`;
